import { Button } from "@/components/ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import React from "react";

interface CalendarHeaderProps {
  month: number;
  year: number;
  setMonth: (month: number) => void;
  setYear: (year: number) => void;
}

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  month,
  year,
  setMonth,
  setYear,
}) => {
  const handleToday = () => {
    const today = new Date();
    setMonth(today.getMonth() + 1);
    setYear(today.getFullYear());
  };

  const handlePrevMonth = () => {
    if (month === 1) {
      setMonth(12);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
  };

  const handleNextMonth = () => {
    if (month === 12) {
      setMonth(1);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
  };

  return (
    <div className="flex items-center justify-between px-2 py-4">
      <div className="text-xl font-bold">
        {months[month - 1]} {year}
      </div>
      <div className="flex items-center space-x-1">
        <Button
          variant="ghost"
          onClick={handleToday}
          className="p-1 active:opacity-70"
        >
          Today
        </Button>
        <button onClick={handlePrevMonth} className="p-1 active:opacity-70">
          <ChevronLeftIcon className="h-5 w-5" />
        </button>
        <button onClick={handleNextMonth} className="p-1 active:opacity-70">
          <ChevronRightIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};
